import includes from 'lodash/includes';
import {types} from '../utils';

const isAllowedComponentAPI = (type, api) => {
    const apis = types.supportedComponentAPIs[type] || [];
    return includes(apis, api);
};

export default isAllowedComponentAPI;



// WEBPACK FOOTER //
// ./js/modules/privates/utils/componentAPISupport.es6